export default {
  methods: {
    updateFinalImages: function () {
      var self = this
      const url = '/imagedesk/image/update/final'
      let data = {
        id_pairs: self.$store.getters.updateImagesSet,
        id_product: self.selectedProduct.id_product,
        order: self.$store.getters.updateSequenceSet
      }
      self.resequencingImages = 'pending'
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateimagesUpdateRequired', false)
          self.$store.dispatch('updateimagesUpdateSet', [])
          self.$store.dispatch('updateSequenceUpdateSet', [])
          self.getProductImages()
          self.getFinalSequence()
          self.resequencingImages = 'done'
          setTimeout(function () {
            self.resequencingImages = ''
          }, 2000)
        })
        .catch(function (error) {
          // self.$store.dispatch("updateToast", {
          //     text: error.response.data.error,
          //     show: true
          // });
        })
    },
    markDelete: function (data) {
      var self = this
      var image = data

      if (image.is_marked_delete && image.is_marked_delete == 1) {
        if (self.updateImagesSet) {
          var newSet = _.remove(self.updateImagesSet, function (item) {
            return item.id_product_image === parseInt(image.id_product_image)
          })
          self.$store.dispatch('updateimagesUpdateSet', self.updateImagesSet)
          if (self.updateImagesSet == 0) {
            self.$store.dispatch('updateimagesUpdateRequired', false)
          }
        }
        image.is_marked_delete = 0
        return true
      }

      if (self.updateImagesSet) {
        self.updateImagesSet.push({
          id_product_image: image.id_product_image,
          id_image: null
        })
      }
      self.$set(image, 'is_marked_delete', 1)
      self.$store.dispatch('updateimagesUpdateRequired', true)
      self.$store.dispatch('updateimagesUpdateSet', self.updateImagesSet)
    }
  }

}
